import { render, staticRenderFns } from "./EnterScreen.vue?vue&type=template&id=6d8b5129&scoped=true&"
var script = {}
import style0 from "./EnterScreen.vue?vue&type=style&index=0&id=6d8b5129&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b5129",
  null
  
)

export default component.exports